import styled from 'styled-components';

export const StyledFooter = styled.div`
  .Polaris-FooterHelp__Text {
    display: flex;
    align-items: center;
    gap: 5rem;
    flex-wrap: wrap;

    .Polaris-Link {
      font-size: 0.75rem;
    }
  }

  /* BFS TR-438 followup: at ≤ 489px the 5rem gap pushes "Visit our site" past the
     right edge and clips "Need help?" off the left (205 + 80 + 122 = 407 vs ≈375
     content width). Shrink the gap and centre the links so they wrap and stay
     fully visible inside the customize fullscreen editor and any other narrow view. */
  @media (max-width: 489px) {
    .Polaris-FooterHelp__Text {
      gap: 1rem;
      justify-content: center;
      row-gap: 0.25rem;
    }
  }
`;
